import { getCountryForTimezone } from 'countries-and-timezones';

// Kraj usera wyliczamy z timezone urządzenia (Intl) - tak samo jak backend liczy
// signupCountry. Zwraca kod ISO 3166-1 alpha-2 (np. "PL") albo null.
export const resolveCountryFromTimezone = (): string | null => {
  try {
    const timezone: string | undefined = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (!timezone) {
      return null;
    }
    return getCountryForTimezone(timezone)?.id ?? null;
  } catch {
    return null;
  }
};
